import{__rest as n}from"../_virtual/_tslib.js";import{jsx as e,jsxs as i}from"react/jsx-runtime";import{Fonts as t}from"@vds-core/typography";import{calculateRem as o,withVDSManager as r}from"@vds-core/utilities";import{AccessibilityTokens as a}from"@vds-tokens/accessibility";import{ColorTokens as l}from"@vds-tokens/color";import{LayoutTokens as c}from"@vds-tokens/layout";import{TypographyTokens as s}from"@vds-tokens/typography";import d,{css as u}from"styled-components";const p=e("svg",{version:"1.1",id:"Layer_1",xmlns:"http://www.w3.org/2000/svg",x:"0px",y:"0px",viewBox:"0 0 21.6 21.6",children:e("path",{d:"M14.1,20.7l-9.9-9.9l9.9-9.9l2.5,2.5l-7.3,7.3l7.3,7.3L14.1,20.7z"})}),f=e("svg",{version:"1.1",id:"Layer_1",xmlns:"http://www.w3.org/2000/svg",x:"0px",y:"0px",viewBox:"0 0 21.6 21.6",children:e("path",{d:"M7.6,20.7L5,18.1l7.3-7.3L5,3.5l2.5-2.5l9.9,9.9L7.6,20.7z"})}),h=l.elements.primary.onlight.value,v=l.elements.primary.ondark.value,$=l.interactive.disabled.onlight.value,g=l.interactive.disabled.ondark.value,m=a.color.focusring.onlight.value,b=a.color.focusring.ondark.value,y=s.fontweight.bold.value,x=s.fontsize.body[16].value,w=s.fontsize.body[16].value,k=s.lineheight.body[20].value,S=s.lineheight.body[20].value,C="0.35s",I="cubic-bezier(0.22, 0.61, 0.36, 1.0)",V=o(44),_=o(c.space["1X"].value),z=a.focusring.borderwidth.value,L=a.focusring.space.offset.value,G=o(12),A=`calc(100% + ${o(parseInt(L,10))})`,D=function(n){return"dark"===n?l.interactive.active.ondark.value:l.interactive.active.onlight.value},P=d.span.withConfig({displayName:"Wrapper",componentId:"VDS__sc-o7am1d-0"})`
  width: 100%;
  height: 100%;
  position: relative;
  display: inline-flex;
  &:focus {
    outline: none;
  }
`,R=d.a.withConfig({displayName:"StyledAnchor",componentId:"VDS__sc-o7am1d-1"})`
  align-content: center;
  align-items: ${function({$iconPosition:n}){return n&&"right"===n?"center":"flex-start"}};
  background-color: transparent;
  background-image: none;
  border: 0;
  color: ${h};
  cursor: pointer;
  display: flex;
  font-size: ${function({viewport:n}){return"desktop"===n?x:w}};
  font-family: ${t.VerizonNHGeDS};
  font-style: normal;
  font-weight: ${y};
  letter-spacing: ${o(s.letterspacing.wide.value)};
  line-height: ${function({viewport:n}){return"desktop"===n?k:S}};
  position: relative;
  text-decoration: none;
  touch-action: manipulation;
  width: fit-content;
  pointer-events: auto; /* to ensure this click event works when used in a TileContainer */
  -webkit-tap-highlight-color: transparent;

  * {
    pointer-events: none; /* pointer-events is added here to ensure the correct item is returned by the onclick handler */
    outline: none;
  }

  &:active {
    outline: none;
    color: ${function({$colorActive:n}){return n}};
  }

  &:active svg path {
    fill: ${function({$colorActive:n}){return n}};
  }

  ${function({surface:n,$colorActiveInverted:e}){return"dark"===n&&`\n    color: ${v};\n    &:active {\n      color: ${e};\n    }\n\n    &:active svg path {\n      fill: ${e};\n    }\n  `}};

  ${function({disabled:n}){return n&&`\n    pointer-events: none;\n    cursor: not-allowed;\n    color: ${$};\n  `}};

  ${function({disabled:n,surface:e}){return n&&"dark"===e&&`\n    color: ${g};\n  `}};

  ${function({surface:n,$focusRingBorderRadius:e}){return`\n     &:focus:not(:hover)  {\n      outline: none;\n      &::before {\n        border: ${o(z)} ${a.focusring.borderstyle.value} ${"dark"===n?b:m};\n        content: '';\n        height: ${A};\n        border-radius: ${e};\n        left: 50%;\n        position: absolute;\n        top: 50%;\n        transform: translate(-50%, -50%);\n        width: ${A};\n      }\n    }\n    &:focus:not(:hover):not(:focus-visible) {\n      &:before {\n        display: none; // Only display focus state on keyboard focus, not when radio button is clicked\n      }\n    }\n    &:focus {\n      outline: none;\n    }\n  `}};

  ${function({$iconPosition:n}){return` \n      svg {\n        transform: translateX(0);\n        transition: transform ${I} ${C};\n      }\n      &:hover {\n        outline: none;\n      }\n      &:hover svg {\n        position: relative;\n        transform: ${"right"===n?"translateX(4px)":"translateX(-4px)"};\n        transition: transform ${C} ${I};\n      }\n\n  `}};
`,W=d.span.withConfig({displayName:"HitArea",componentId:"VDS__sc-o7am1d-2"})`
  cursor: pointer;
  display: inline-block;
  height: ${V};
  left: 50%;
  position: absolute;
  text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
`,N=d.span.withConfig({displayName:"AnchorContentWrapper",componentId:"VDS__sc-o7am1d-3"})`
  display: inline-block;
  pointer-events: none;
`,B=d.span.withConfig({displayName:"TextWrapper",componentId:"VDS__sc-o7am1d-4"})`
  display: inline-flex;
  pointer-events: none;
`,T=d.span.withConfig({displayName:"InlineWrapper",componentId:"VDS__sc-o7am1d-5"})`
  display: inline-flex;
`,X=d.span.withConfig({displayName:"IconWrapper",componentId:"VDS__sc-o7am1d-6"})`
  pointer-events: none;
  display: inline-flex;
  position: relative;
  height: ${k};
  min-width: ${G};
  padding: ${function({$iconPosition:n}){return"left"===n?`0px ${_} 0px 0px`:`0px 0px 0px ${_}`}};
  svg {
    position: relative;
    top: ${function({$iconPosition:n}){return"right"===n?"5px":"4px"}};
  }
`,j=d.div.withConfig({displayName:"IconSVGWrapper",componentId:"VDS__sc-o7am1d-7"})`
  display: flex;
  min-width: ${function({$iconSizeSVG:n}){return o(n)}};
  min-height: ${function({$iconSizeSVG:n}){return o(n)}};
  width: ${function({$iconSizeSVG:n}){return o(n)}};
  height: ${function({$iconSizeSVG:n}){return o(n)}};
  ${function({tabIndex:n}){return n&&n<0&&"\n  outline: none;\n  pointer-events: none;\n"}};
  &:active,
  &:focus {
    outline: none;
  }
  ${function({$iconColorSVG:n}){return u`
    svg {
      width: ${function({$iconSizeSVG:n}){return o(n)}};
      height: ${function({$iconSizeSVG:n}){return o(n)}};
      path {
        fill: ${n};
      }
    }
  `}}
`;function E(n,e){let i="dark"===e?v:h;return n&&(i="dark"===e?g:$),i}function K(n){let e="";return n.forEach((function(i,t){t!==n.length-1&&(e+=`${i} `)})),e}function H(n){const e=n.length-1,i=n[e],t="string"!=typeof n[e],o="string"==typeof n,r=[];if(void 0===n.length||n.length<=1)return{childArray:[],textWithCaret:n};if(t||!o)return n.forEach((function(n,i){i!==e&&(r[i]=n)})),{childArray:r,textWithCaret:i};const a=n.trim().split(" "),l=a[a.length-1];return{childArray:K(a),textWithCaret:l}}function M(n,t){const{iconPosition:o,children:r}=n,a=r?H(r).childArray:[],l=r?H(r).textWithCaret:"";return i(T,{role:"text",children:["left"===o&&e(X,{tabIndex:-1,$iconPosition:o,"aria-hidden":!0,children:e(j,{tabIndex:-1,"aria-hidden":!0,"aria-label":"left-caret-bold icon",$iconColorSVG:t,$iconSizeSVG:12,children:p})}),i(N,{tabIndex:-1,"aria-hidden":!0,children:[a,i(B,{children:[l,"right"===o&&e(X,{tabIndex:-1,$iconPosition:o,"aria-hidden":!0,children:e(j,{tabIndex:-1,"aria-hidden":!0,$iconColorSVG:t,$iconSizeSVG:12,"aria-label":"right-caret-bold icon",children:f})})]})]})]})}const O=function(t){const{iconPosition:o,dataLoc:r,viewport:a,$focusRingBorderRadius:l,disabled:c,tabIndex:s,role:d,surface:u,textLinkCaretRef:p}=t,f=n(t,["iconPosition","dataLoc","viewport","$focusRingBorderRadius","disabled","tabIndex","role","surface","textLinkCaretRef"]),h=D(u),v=D(u),$="tablet"===a?"desktop":a;return i(R,Object.assign({},f,{ref:p,"data-testid":"TextLinkCaret","data-loc":r,href:t.href,disabled:t.disabled,surface:t.surface,viewport:$,role:d,"aria-disabled":t.disabled,"aria-label":t.ariaLabel?t.ariaLabel:t.children&&"string"==typeof t.children?t.children:"Text Link Caret",$iconPosition:o,tabIndex:c?-1:s||0,$colorActive:h,$colorActiveInverted:v,$focusRingBorderRadius:l,onKeyDown:function(n){t.onKeyDown&&t.onKeyDown(n),"Enter"!==n.key&&" "!==n.key||t.onClick&&t.onClick(n)},onClick:function(n){t.onClick&&t.onClick(n)},children:[e(W,{tabIndex:-1,"aria-hidden":!0}),e(P,{tabIndex:-1,"aria-hidden":!0,children:M(t,E(t.disabled,t.surface))})]}))};O.defaultProps={viewport:"desktop",iconPosition:"right",disabled:!1,surface:"light",role:"link",$focusRingBorderRadius:"2px"};var q=r(O);export{q as default};
